<template>
  <div class="container">
    <div class="handle-box">
      <el-input v-model="query.name" placeholder="企业名称" class="handle-input mr10"></el-input>
      <el-input v-model="query.corporation" placeholder="法人" class="handle-input mr10"></el-input>
      <el-input v-model="query.contact_name" placeholder="联系人" class="handle-input mr10"></el-input>
      <el-input v-model="query.contact_phone" placeholder="联系电话" class="handle-input mr10"></el-input>
      <el-select v-model="query.is_validate" clearable placeholder="是否有效" class="handle-select mr10">
        <el-option key="1" label="有效" value="1"></el-option>
        <el-option key="2" label="无效" value="0"></el-option>
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="handleAdd">添加</el-button>
    </div>
    <el-table :data="tableData" border class="table" ref="multipleTable" header-cell-class-name="table-header"
      :cell-style="centerStyle">
      <el-table-column prop="id" label="ID" align="center" width="105"></el-table-column>
      <el-table-column prop="name" label="企业名称" align="center">
        <template #default="scope">
          <el-button type="text" @click="showDetail(scope.row)">
            {{ scope.row.name }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column prop="contact_name" label="联系人" align="center" width="180"></el-table-column>
      <el-table-column prop="contact_phone" label="联系电话" width="180" align="center"></el-table-column>
      <el-table-column prop="service_start_time" label="签约时间" align="center" width="210"></el-table-column>
      <el-table-column label="是否有效" width="120" align="center">
        <template #default="scope">
          <el-button type="text" :style="'color:' + [!scope.row.is_validate ? 'red' : '']"
            @click="setIsvalidate(scope.$index, scope.row.id, !scope.row.is_validate)">
            {{ scope.row.is_validate ? "有效" : "无效" }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="320" header-align="center">
        <template #default="scope">
          <el-button icon="el-icon-edit" size="mini" type="text"
            @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button icon="el-icon-user-solid" size="mini" type="text" @click="getStaff(scope.row)">员工管理</el-button>
          <el-button icon="el-icon-link" size="mini" type="text" @click="handleStore(scope.row)">绑定门店</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination background layout="total, prev, pager, next" :current-page="query.page"
        :page-size="query.page_size" :total="pageTotal" @current-change="handlePageChange"></el-pagination>
    </div>
    <!-- 编辑加盟商 -->
    <el-dialog :title="code ? '添加' : '编辑'" v-model="companyVisible" width="60%">
      <el-tabs v-model="activeName">
        <el-tab-pane name="first" label="基本信息">
          <el-form ref="form" :model="form" class="el-dialog__body" label-width="180px" :rules="companyRules">
            <el-form-item label="加盟类型:" prop="join_type">
              <el-select v-model="form.join_type" placeholder="请选择加盟类型" class="w200" @change="changeType">
                <el-option v-for="item in join_types" :key="item.value" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="联系人:" prop="contact_name">
              <el-input v-model="form.contact_name" class="w120" placeholder="请输入联系人·"></el-input>
            </el-form-item>
            <el-form-item label="联系电话:" prop="contact_phone">
              <el-input v-model="form.contact_phone" class="w200" placeholder="请输入联系电话"></el-input>
            </el-form-item>
            <el-form-item label="企业名称:" prop="name" v-if="form.join_type == 1">
              <el-input v-model="form.name" class="w400" placeholder="请输入企业名称"></el-input>
            </el-form-item>
            <el-form-item label="统一社会信用代码:" prop="credit_code" v-if="form.join_type == 1">
              <el-input v-model="form.credit_code" class="w200" placeholder="请输入统一社会信用代码"></el-input>
            </el-form-item>
            <el-form-item label="法人:" prop="corporation" v-if="form.join_type == 1">
              <el-input v-model="form.corporation" class="w120" placeholder="请输入法人"></el-input>
            </el-form-item>
            <el-form-item label="营业执照:" v-if="form.join_type == 1">
              <Upload @newImage='getNewImage' :value="form.license" imgName="license" v-if="form.license !== null">
              </Upload>
            </el-form-item>
            <el-form-item label="法人身份证正反面:">
              <el-alert title="建议尺寸450（宽）*300（长）" type="success" style="margin-bottom: 10px;" />
              <div class="identity">
                <Upload @newImage='getNewImage' :value="form.identity_card_front" imgName="identity_card_front"
                  v-if="form.identity_card_front !== null"></Upload>
              </div>
              <div class="identity">
                <Upload @newImage='getNewImage' :value="form.identity_card_back" imgName="identity_card_back"
                  v-if="form.identity_card_back !== null"></Upload>
              </div>
            </el-form-item>

            <el-form-item label="备注:">
              <el-input type="textarea" v-model="form.note" class="w80" maxlength="500" show-word-limit rows="10"
                resize="none"></el-input>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane name="second" label="签约信息">
          <el-form ref="form" :model="form" class="el-dialog__body" label-width="180px" :rules="companyRules">
            <el-form-item label="签约时间:" prop="contract_time">
              <el-date-picker v-model="form.service_start_time" type="date" placeholder="选择签约时间" class="w200"
                format="YYYY-MM-DD" @change="getEndTime"></el-date-picker>
            </el-form-item>
            <el-form-item label="签约时长:" prop="contract_duration">
              <el-select v-model="form.contract_duration" placeholder="请选择签约时长" class="w200" @change="getEndTime">
                <el-option v-for="item in timeInfo" :key="item.value" :label="item.label"
                  :value="item.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="结束时间:">
              <el-date-picker v-model="end_time" type="date" class="w200" format="YYYY-MM-DD" disabled></el-date-picker>
            </el-form-item>
            <el-form-item label="收费标准:">
              <el-input v-model="form.fee_standard" class="w200" placeholder="请输入收费标准"></el-input>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane name="third" label="结算信息">
          <el-form ref="form" :model="form" class="el-dialog__body" label-width="180px" :rules="companyRules">
            <el-form-item prop="is_sharing" label="是否分账：">
              <el-switch v-model="form.is_sharing" placeholder="请选择是否分账"></el-switch>
            </el-form-item>
            <el-form-item label="商户号:" prop="receiver_id" required>
              <el-input v-model="form.receiver_id" class="w200" placeholder="请输入商户号"></el-input>
            </el-form-item>
            <el-form-item label="结算账户名称:" prop="account_name">
              <el-input v-model="form.account_name" class="w200" placeholder="请输入结算账户名称"></el-input>
            </el-form-item>
            <el-form-item label="银行卡号:" prop="bank_card_number">
              <el-input v-model="form.bank_card_number" class="w400" placeholder="请输入银行卡号"></el-input>
            </el-form-item>
            <el-form-item label="开户行名称:" prop="bank_name">
              <el-input v-model="form.bank_name" class="w200" placeholder="请输入开户行名称"></el-input>
            </el-form-item>
            <el-form-item label="结算类型:" prop="receiver_type">
              <el-input v-model="form.receiver_type" class="w200" placeholder="请输入结算类型"></el-input>
            </el-form-item>
            <el-form-item label="结算手续费比例:" prop="sharing_rate">
              <el-input-number v-model="form.sharing_rate" class="w200" placeholder="请输入结算手续费比例"
                :controls="false"></el-input-number>
            </el-form-item>
            <el-form-item label="验证材料:">
              <Upload @newImage='getNewImage' :value="form.proof_material" imgName="proof_material"
                v-if="form.proof_material !== null">
              </Upload>
            </el-form-item>
            <el-form-item label="身份证正反面:">
              <el-alert title="建议尺寸450（宽）*300（长）" type="success" style="margin-bottom: 10px;" />
              <div class="identity">
                <Upload @newImage='getNewImage' :value="form.id_card_front_image" imgName="id_card_front_image"
                  v-if="form.id_card_front_image !== null"></Upload>
              </div>
              <div class="identity">
                <Upload @newImage='getNewImage' :value="form.id_card_back_image" imgName="id_card_back_image"
                  v-if="form.id_card_back_image !== null"></Upload>
              </div>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>

      <template #footer>
        <span class="dialog-footer">
          <el-button @click="companyVisible = false">取 消</el-button>
          <el-button type="primary" @click="saveEdit">确 定</el-button>
        </span>
      </template>
    </el-dialog>
    <!--  添加员工弹窗-->
    <el-dialog title="添加员工" v-model="staffVisible" width="25%">
      <el-form ref="form" :model="staffForm" label-width="130px">
        <el-form-item label="姓名" required>
          <el-input v-model="staffForm.name"></el-input>
        </el-form-item>
        <el-form-item label="手机号" required>
          <el-input v-model="staffForm.phone"></el-input>
        </el-form-item>
        <el-form-item label="角色" required>
          <el-select v-model="staffForm.role_id" placeholder="请选择">
            <el-option v-for="item in roleList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="staffVisible = false">取 消</el-button>
          <el-button type="primary" @click="addStaffEdit">确 定</el-button>
        </span>
      </template>
    </el-dialog>
    <!--  加盟详情弹窗-->
    <el-dialog title="加盟详情" v-model="detailVisible" width="60%">
      <el-tabs v-model="activeDetailName">
        <el-tab-pane name="first" label="基本信息">
          <div class="detail_box">
            <div class="box_top">
              <div class="box_left">
                <el-form>
                  <el-form-item label="类型:">
                    {{ companyTypeMap.get(companyDetail.type) }}
                  </el-form-item>
                  <el-form-item label="加盟类型:">{{ companyDetail.join_type == 1 ? '企业' : '个人' }}</el-form-item>
                  <el-form-item label="企业名称:" v-if="join_type == 1">{{ companyDetail.name }}</el-form-item>

                  <el-form-item label="统一社会信用代码:" v-if="join_type == 1">{{ companyDetail.credit_code }}</el-form-item>
                </el-form>
              </div>
              <div class="box_right" v-if="join_type == 1">
                <el-image :src="companyDetail.license"></el-image>
                <p>（营业执照）</p>
              </div>
            </div>
            <div class="box_bottom">
              <el-form>
                <el-form-item label="法人:" v-if="join_type == 1">{{ companyDetail.corporation }}</el-form-item>
                <div>
                  <div class="image">
                    <el-image :src="companyDetail.identity_card_front">
                    </el-image>
                    <p>（法人身份证正面照）</p>
                  </div>
                  <div class="image">
                    <el-image :src="companyDetail.identity_card_back">
                    </el-image>
                    <p>（法人身份证反面照）</p>
                  </div>
                </div>
                <el-form-item label="联系人:">{{ companyDetail.contact_name }}</el-form-item>
                <el-form-item label="联系电话:">{{ companyDetail.contact_phone }}</el-form-item>
                <el-form-item label="是否有效:">{{ companyDetail.is_validate ? '有效' : '无效' }}</el-form-item>
                <el-form-item label="备注:">{{ companyDetail.note }}</el-form-item>
                <el-form-item label="录入时间:">{{ ForMatHMS(companyDetail.c_at) }}</el-form-item>
              </el-form>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane name="second" label="签约信息">
          <el-form ref="form" :model="form" class="el-dialog__body" label-width="180px" :rules="companyRules">
            <el-form-item label="签约时间:" prop="contract_time">{{ companyDetail.service_start_time }}
            </el-form-item>
            <el-form-item label="签约时长:" prop="contract_duration">{{ companyDetail.contract_duration }}
            </el-form-item>
            <el-form-item label="结束时间:">{{ end_time }}
            </el-form-item>
            <el-form-item label="收费标准:">{{ companyDetail.fee_standard }}
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane name="third" label="结算信息">
          <el-form ref="form" :model="form" class="el-dialog__body" label-width="180px" :rules="companyRules">
            <el-form-item prop="is_sharing" label="是否分账：">{{ companyDetail.is_sharing ? '是' : '否' }}
            </el-form-item>
            <el-form-item label="商户号:" prop="receiver_id" required>{{ companyDetail.receiver_id }}
            </el-form-item>
            <el-form-item label="结算账户名称:" prop="account_name">{{ companyDetail.account_name }}
            </el-form-item>
            <el-form-item label="银行卡号:" prop="bank_card_number">{{ companyDetail.bank_card_number }}
            </el-form-item>
            <el-form-item label="开户行名称:" prop="bank_name">{{ companyDetail.bank_name }}
            </el-form-item>
            <el-form-item label="结算类型:" prop="receiver_type">{{ companyDetail.receiver_type }}
            </el-form-item>
            <el-form-item label="结算手续费比例:" prop="sharing_rate">{{ companyDetail.sharing_rate }}
            </el-form-item>
            <el-form-item label="验证材料:"><img :src="companyDetail.proof_material" alt="">
            </el-form-item>
            <el-form-item label="身份证正反面:">
              <img :src="companyDetail.id_card_front_image" alt="">
              <img :src="companyDetail.id_card_back_image" alt="">
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>

    </el-dialog>
    <!--  企业员工弹窗-->
    <el-dialog title="员工" v-model="staffDialog" width="60%">
      <el-button type="primary" icon="el-icon-plus" @click="addStaff()" class="mb10">添加员工
      </el-button>
      <el-table :data="staffData" border class="table" ref="multipleTable" header-cell-class-name="table-header"
        :cell-style="centerStyle">
        <el-table-column prop="id" label="ID" align="center" width="55"></el-table-column>
        <el-table-column prop="name" label="姓名" align="center"></el-table-column>
        <el-table-column prop="role_name" label="角色" align="center"></el-table-column>
        <el-table-column prop="phone" label="手机号" align="center"></el-table-column>
        <el-table-column prop="is_validate" label="是否有效" align="center">
          <template #default="scope">
            {{ scope.row.is_validate ? '有效' : '无效' }}
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background layout="total, prev, pager, next" :current-page="staff_query.page"
          :page-size="staff_query.page_size" :total="staffPageTotal"
          @current-change="handleStaffPageChange"></el-pagination>
      </div>
    </el-dialog>
    <!--  分配加盟商-->
    <el-dialog title="分配加盟商" v-model="bindDialog" width="60%">
      <el-transfer v-model="checkedFranchisee" style="text-align: left; display: inline-block"
        :render-content="renderFunc" filterable :titles="['所有加盟商', '已绑定的加盟商']" :format="{
          noChecked: '${total}',
          hasChecked: '${checked}/${total}',
        }" :data="franchiseeList">
      </el-transfer>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="bindDialog = false">取 消</el-button>
          <el-button type="primary" @click="saveFranchisee">确 定</el-button>
        </span>
      </template>
    </el-dialog>
    <!-- 修改类型 -->
    <el-dialog title="修改类型" v-model="editTypeVisible" width="25%">
      <el-form ref="form" label-width="70px">
        <el-form-item label="角色" required>
          <el-select v-model="type" placeholder="请选择">
            <el-option v-for="item in typeMap" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-tooltip class="item" effect="dark" content="修改类型之后请在商户后台管理系统对所有员工重新设置身份" placement="top-start">
            <el-button class="el-button-problem" icon="el-icon-warning-outline" type="text"></el-button>
          </el-tooltip>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="editTypeVisible = false">取 消</el-button>
          <el-button type="primary" @click="saveType()">确 定</el-button>
        </span>
      </template>
    </el-dialog>
    <!-- 分账信息配置 -->
    <el-dialog title="商户支付信息" v-model="AccountVisible" width="30%">
      <el-form ref="form" :model="accountForm" label-width="120px">
        <el-form-item prop="isSharing" label="是否分账：">
          <el-switch v-model="accountForm.isSharing"></el-switch>
        </el-form-item>
        <el-form-item label="商户号" prop="receiverId" required>
          <el-input v-model="accountForm.receiverId" style="width: 100px;"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="AccountVisible = false">取 消</el-button>
          <el-button type="primary" @click="saveAccount()">确 定</el-button>
        </span>
      </template>
    </el-dialog>
    <!-- 添加或绑定门店 -->
    <el-dialog title="门店绑定" v-model="StoreVisible" width="70%">
      <div style="margin-left: 20px;margin-bottom: 10px;display: inline-block;" v-if="bindStoreList.length > 0">已绑门店:
      </div>
      <div v-for="(item, index) in bindStoreList" :key="index" class="name-list">{{ item.name }}</div>
      <el-tabs tab-position="left" style="height: 60vh;">
        <el-tab-pane label="新建门店进行绑定">
          <el-form ref="form" :model="form" class="el-dialog__body" label-width="105px" :rules="rules">
            <el-form-item label="门店名" prop="name">
              <el-input v-model="form.name" class="w400"></el-input>
            </el-form-item>
            <el-form-item label="封面">
              <el-alert title="建议尺寸780（长）*560（宽）" type="success" style="margin-bottom: 10px;" />
              <el-upload class="avatar-uploader avater2" :show-file-list="false" :on-change="handleCoverChange"
                list-type="picture-card" :auto-upload="false">
                <img v-if="form.cover" :src="form.cover" class="avatar2">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
            <el-form-item label="开放地址">
              <el-select v-model="form.area_id">
                <el-option v-for="item in area_options" :key="item.value" :value="item.value"
                  :label="item.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="">
              <el-button type="primary" @click="saveAccount()" style="width: 200px;">添加并绑定</el-button>
            </el-form-item>
            <el-form-item label="提示">
              此处仅上传了一些基本资料，更多详细信息请前往门店管理进行配置
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="选择已有门店绑定">
          <el-input v-model="store_query.name" placeholder="请输入门店名称"
            style="width: 200px;margin-bottom: 10px;margin-right: 10px;"></el-input><el-button type="primary"
            icon="el-icon-search" @click="getAllStore(company_id)">搜索</el-button>
          <div class="all-store">
            <el-table :data="StoreData" ref="multipleTable" class="table" header-cell-class-name="table-header"
              :cell-style="centerStyle">
              <el-table-column prop="id" label="ID" align="center" width="55"></el-table-column>
              <el-table-column prop="name" label="门店名称" align="center"></el-table-column>
              <el-table-column label="封面" align="center" width="100" header-align="center">
                <template #default="scope">
                  <el-image class="table-td-thumb" :src="scope.row.cover" :preview-src-list="[scope.row.cover]"
                    :hide-on-click-modal="true"></el-image>
                </template>
              </el-table-column>
              <el-table-column label="营业时间" align="center">
                <template #default="scope">
                  {{ getNumberHour(scope.row.start_hour, true) }}
                  -
                  {{ getNumberHour(scope.row.end_hour, true) }}
                </template>
              </el-table-column>
              <el-table-column prop="phone" label="联系电话" align="center"></el-table-column>
              <el-table-column label="是否有效" width="100" align="center">
                <template #default="scope">
                  <span>
                    {{ scope.row.is_validate ? "有效" : "无效" }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="100" align="center">
                <template #default="scope">
                  <el-button type="primary" @click="bindStore(scope.row.id)" v-if="!scope.row.checked">绑定</el-button>
                  <el-button type="danger" @click="underStore(scope.row.id)" v-else>解绑</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
import {
  addCompanyStaff,
  getAgentFranchisee,
  getCompanyDeatil,
  getCompanyList,
  getCompanyOptions, getCompanyRole,
  getCompanyStaff,
  saveCompany, setAgentFranchisee,
  setCompanyIsValidate, setCompanyType,
  setAccountInfo,
  getAccount
} from "@/api/company";
import { getStoreList } from "@/api/store";
import { rfcToTime } from "@/utils/defaultTime";
import Upload from "@/components/Upload.vue";
import { ElOption, ElPagination, ElTableColumn, ElTooltip } from "element-plus";

export default {
  name: "CompanyTable",
  components: { ElTooltip, ElOption, ElPagination, ElTableColumn, Upload },
  data() {
    return {
      action: 'https://wx.yixiankeji.com/admin/upload',
      query: {
        name: '',
        type: 1,
        license: null,
        credit_code: "",
        corporation: '',
        identity_card_front: '',
        identity_card_back: '',
        contact_name: '',
        contact_phone: '',
        is_validate: '',
        note: '',
        page: 1,
        page_size: 10
      },
      form: {
        id: null,
        name: '',
        license: null,
        credit_code: "",
        corporation: '',
        identity_card_front: '',
        identity_card_back: '',
        contact_name: '',
        contact_phone: '',
        is_validate: '',
        note: '',
        type: 1,
        join_type: 1,
        service_start_time: '',
        contract_duration: ''
      },
      tableData: [],
      pageTotal: 0,
      companyType: [],
      companyTypeMap: new Map(),
      code: true,
      companyVisible: false,
      companyRules: {
        name: [{ required: true, message: '请输入企业名称', trigger: 'blur' }],
        type: [{ required: true, message: '请输入企业类型', trigger: 'blur' }],
        contact_name: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
        contact_phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { min: 11, max: 11, message: '请输入正确的联系电话', trigger: 'blur' }
        ],
        credit_code: [
          { max: 18, message: '最多输入18位', trigger: 'blur' },
          { required: true, message: '请输入统一社会信用代码', trigger: 'blur' }
        ],
      },
      staffForm: {
        company_id: null,
        name: '',
        phone: '',
        role_id: null
      },
      staffVisible: false,
      companyDetail: {},
      detailVisible: false,
      staffData: [],
      staff_query: {
        company_id: null,
        page: 1,
        page_size: 10
      },
      staffDialog: false,
      staffPageTotal: 0,
      bindDialog: false,
      checkedFranchisee: [],
      franchiseeList: [],
      typeMap: [
        {
          value: 1,
          label: '加盟商'
        },
        {
          value: 2,
          label: '代理商'
        }
      ],
      franchisee_query: {
        id: null,
        ids: ''
      },
      roleList: [],
      editTypeVisible: false,
      type: null,
      typeOptions: [],
      roleForm: {},
      AccountVisible: false,
      accountForm: {
        isSharing: false,
        id: null
      },
      StoreVisible: false,
      StoreData: [],
      store_query: {
        page: 1,
        page_size: 999,
        name: ''
      },
      bindStoreList: {},
      company_id: null,
      join_types: [
        {
          value: 1,
          label: '企业'
        },
        {
          value: 2,
          label: '个人'
        }
      ],
      activeName: 'first',
      timeInfo: [
        {
          label: '1年',
          value: 1
        },
        {
          label: '2年',
          value: 2
        },
        {
          label: '3年',
          value: 3
        },
        {
          label: '4年',
          value: 4
        },
        {
          label: '5年',
          value: 5
        },
        {
          label: '不限期',
          value: 99999999
        },
      ],
      end_time: '',
      activeDetailName: 'first',
      timeMap: new Map()
    }
  },
  created() {
    this.getData()
    this.getCompanyType()
    this.getTimeMap()
  },
  methods: {
    handleAccount(row) {
      this.$nextTick(() => {
        getAccount(row.id).then(res => {
          this.accountForm = res.data
          this.accountForm.id = row.id
        })
        this.AccountVisible = true
      })
    },
    renderFunc(h, option) {
      return <span title={option.label}>{option.label}</span>;
    },
    tabClick() {
      this.query.page = 1
      this.getData()
    },
    centerStyle() {
      return 'text-align:center'
    },
    getTimeMap() {
      this.timeInfo.forEach(item => {
        this.timeMap.set(item.label, item.value)
      })
    },
    getNewImage(e) {
      for (let key in this.form) {
        if (key === e.imgName) {
          this.form[key] = e.imgUrl
        }
      }
    },
    getData() {
      getCompanyList(this.query).then(res => {
        this.tableData = res.data
        if (this.query.page === 1) {
          this.pageTotal = res.count
        }
      })
    },
    ForMatHMS(date) {
      return moment(parseInt(date + "000")).format("YYYY-MM-DD HH:mm:ss")
    },
    getCompanyType() {
      let that = this
      getCompanyOptions().then(res => {
        res.forEach(function (item) {
          that.companyTypeMap.set(item.value, item.label)
        })
        this.companyType = res
      })
    },// 分页导航
    handlePageChange(val) {
      this.query.page = val
      this.getData()
    },
    dateFormat: function (row, column) {
      const date = row[column.property];
      if (date === undefined) {
        return "";
      }
      return moment(parseInt(date + "000")).format("YYYY-MM-DD")
    },
    //   搜索
    handleSearch() {
      this.query.page = 1
      this.getData()
    },
    handleEdit(index, row) {
      this.code = false
      getCompanyDeatil(row.id).then(res => {
        this.form = JSON.parse(JSON.stringify(res))
        this.form.id = row.id
        this.form.license = res.license
        this.form.identity_card_front = res.identity_card_front
        this.form.identity_card_back = res.identity_card_back
        this.form.service_start_time = new Date(res.service_start_time).toISOString()
        this.getEndTime()
      })
      this.companyVisible = true
    },
    handleAdd() {
      this.code = true
      this.form = {}
      this.form.license = ''
      this.form.identity_card_front = ''
      this.form.identity_card_back = ''
      this.form.join_type = 1
      this.companyVisible = true
    },
    getEndTime() {
      let end_time = Number(rfcToTime(this.form.service_start_time).slice(0, 4)) + this.timeMap.get(this.form.contract_duration) + rfcToTime(this.form.service_start_time).slice(4, 19)
      this.end_time = end_time
    },
    saveEdit() {
      this.form.type = this.query.type
      this.form.service_start_time = rfcToTime(this.form.service_start_time)
      saveCompany(this.form, this.form.id).then(res => {
        if (res) {
          this.$message.success('保存成功')
          this.companyVisible = false
        }
        this.getData()
      })
    },
    setIsvalidate(index, id, isvalidate) {
      setCompanyIsValidate(id, isvalidate).then(res => {
        if (res === true) {
          this.$message.success('保存成功')
          this.tableData[index].is_validate = isvalidate

        }
      })
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
        return
      }
      if (!isJPG) {
        this.$message.error('上传图片必须是JPG格式!');
        return
      }
      return isJPG && isLt2M;
    },
    addStaff() {
      this.staffForm = {}
      this.staffForm.company_id = this.staff_query.company_id
      this.staffVisible = true;
      this.getStaffRole()
    },
    getStaffRole() {
      getCompanyRole(this.staffForm.company_id).then(res => {
        this.roleList = res
      })
    },
    addStaffEdit() {
      this.staffForm.company_id = Number(this.staffForm.company_id)
      addCompanyStaff(this.staffForm.company_id, this.staffForm).then(res => {
        if (res) {
          this.$message.success('添加成功')
          this.staffVisible = false;
          this.getStaff(this.staff_query)
        }
      })
    },
    //展示详情
    showDetail(row) {
      this.detailVisible = true
      getCompanyDeatil(row.id).then(res => {
        this.companyDetail = JSON.parse(JSON.stringify(res))
        this.form = JSON.parse(JSON.stringify(res))
        this.getEndTime()
      })
    },
    //获取企业员工
    getStaff(row) {
      this.staff_query.page = 1
      this.staff_query.company_id = row.id ? row.id.toString() : this.staff_query.company_id
      this.staffDialog = true
      getCompanyStaff(this.staff_query).then(res => {
        this.staffData = res.data
        if (this.staff_query.page === 1) {
          this.staffPageTotal = res.count
        }
      })
    },
    handleStaffPageChange(val) {
      this.staff_query.page = val
      this.getStaff()
    },
    //  分配加盟商
    bindFranchisee(row) {
      this.franchisee_query.id = row.id
      this.getAllFranchisee()
      this.bindDialog = true
      this.checkedFranchisee = []
      this.query.type = 2
      getAgentFranchisee(row.id).then(res => {
        res.forEach(item => {
          this.checkedFranchisee.push(item.id)
        })
      })
    },
    // 获取所有的加盟商
    getAllFranchisee() {
      this.query.type = 1
      this.franchiseeList = []
      getCompanyList(this.query).then(res => {
        res.data.forEach(item => {
          this.franchiseeList.push(
            {
              key: item.id,
              label: item.name,
              disabled: false
            }
          )
        })
      })
    },
    // 分配加盟商
    saveFranchisee() {
      this.franchisee_query.ids = this.checkedFranchisee.toString()
      setAgentFranchisee(this.franchisee_query.id, this.franchisee_query).then(res => {
        if (res === true) {
          this.$message.success('添加成功')
          this.bindDialog = false
        }
      })
    },
    //   修改商户类型
    handleType(row) {
      this.type = this.query.type
      this.editTypeVisible = true
      this.roleForm.id = row.id
    },
    saveType() {
      setCompanyType(this.roleForm.id, this.type).then(res => {
        if (res) {
          this.$message.success('修改成功')
          this.editTypeVisible = false
          this.getData()
        }
      })
    },
    // 设置分账信息
    saveAccount() {
      // this.accountForm.sharingRate = Number(this.accountForm.sharingRate)
      setAccountInfo(JSON.stringify(this.accountForm)).then(res => {
        if (res) {
          this.$message.success('保存成功')
          this.accountVisible = false
          this.getData()
        }
      })
    },
    // 绑定门店
    handleStore(row) {
      this.getBindStore(row.id)
      this.company_id = row.id
      this.StoreVisible = true
    },

    getAllStore(id) {
      getStoreList(this.store_query).then(res => {
        this.StoreData = res.data
        this.StoreData.forEach(item => {
          item.checked = false
          if (item.company_id == id) {
            item.checked = true
          }
        })

      })
    },

    getBindStore(id) {
      this.store_query.name = ''
      getStoreList(this.store_query).then(res => {
        this.StoreData = res.data
        this.bindStoreList = []
        this.StoreData.forEach(item => {
          item.checked = false
          if (item.company_id == id) {
            item.checked = true
            this.bindStoreList.push(item)
          }
        })
      })
    },
    getNumberHour(hour, isNum) {
      if (hour === undefined) {
        return "00"
      }

      if (isNum && hour.length === 5) {
        return hour.slice(0, 2)
      }

      if (!isNum && hour.length === 4) {
        return hour.slice(0, 2)
      }

      if (isNum) {
        if (hour < 10) {
          return "0" + hour + ":00"
        }
        return hour + ":00"
      }

      return "00"
    },

  }
}
</script>

<style scoped>
.select {
  margin-bottom: 10px;
}

.handle-box {
  margin-bottom: 10px;
}

.avatar {
  height: 180px;
  display: block;
}

.handle-input {
  width: 200px;
  display: inline-block;
}

.mr10 {
  margin-right: 10px;
}

.el-select {
  width: 120px;
}

.el-dialog__body {
  height: 50vh;
  overflow: auto;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  line-height: 148px;
  text-align: center;
}

.avatar {
  height: 178px;
  display: block;
}

.table-td-thumb {
  display: block;
  margin: auto;
  width: 40px;
  height: 40px;
}

.w400 {
  width: 400px;
}

.w200 {
  width: 200px;
}

.w120 {
  width: 120px;
}

.identity {
  float: left;
  margin-right: 30px;
}

.detail_box {
  width: 90%;
  margin: 0 auto;
  height: 65vh;
  overflow-x: hidden;
}

.detail_box p {
  text-align: center;
  margin-bottom: 10px;
}

.box_left {
  padding-top: 50px;
  width: 50%;
  float: left;
  box-sizing: border-box;
}

.image {
  width: 40%;
  display: inline-block;
  margin-right: 5%;
  text-align: center;
}

.box_top {
  height: 210px;
}

.box_top .el-form-item {
  height: 40px;
}

.box_right {
  height: 100%;
  width: 40%;
  display: inline-block;
  text-align: center;
}

.box_right .el-image {
  height: 180px;
}

.box_bottom {
  margin-top: 30px;
}

.box_bottom .el-image {
  height: 180px;
  margin: 0 auto;
  margin-bottom: 20px;
}

.w80 {
  width: 80%;
}

/deep/.el-transfer-panel {
  width: 35%;
}

.mb10 {
  margin-bottom: 10px;
}

.el-button-problem {
  font-size: 20px;
  margin-left: 10px;
}

.all-store {
  overflow-y: scroll;
  height: calc(50vh);
}

.name-list {
  display: inline-block;
  margin-left: 20px;
  margin-bottom: 20px;
}

.avatar2 {
  width: 148px;
  height: 148px;
  display: block;
  border-radius: 5px;
}
</style>